export default "__VITE_ASSET__34dca156__"